<template>
  <div>
    <el-dialog
      :title="bigSortNewData.title"
      :visible.sync="bigSortNewData.show"
      width="400px"
      center
    >
      <el-table
        row-key="id"
        id="sortTable"
        :data="tableData"
        border
        :cell-style="{ padding: '1' }"
      >
        <el-table-column
          align="center"
          prop="name"
          :label="$t('GameCategoryName')"
        ></el-table-column>
        <el-table-column align="center"  :label="$t('Actions')">
          <template slot-scope="scope">
            <el-switch
              v-model="tableData[scope.$index].checked"
              :width="35"
              :inactive-text="tableData[scope.$index].checked ? $t('Display') : $t('Hide')"
              style="margin-right: 5px"
              @change="$forceUpdate()"
            >
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmSort(2)"
          >{{$t('SaveCurrentDomain')}}</el-button
        >
        <el-button type="primary" @click="confirmSort(1)"
          >{{$t('SaveAllDomains')}}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Sortable from "sortablejs";
import { normalizeGameTypeSort } from "@/utils/gameTypeSort";
export default {
  props: {
    bigSortNewData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tableData: [],
      gameList: [
        { id: 1, state: 1, name: this.$t("GameTypeSlots") },
        { id: 2, state: 1, name: this.$t("GameTypeTable") },
        { id: 3, state: 1, name: this.$t("GameTypeLive") },
        { id: 4, state: 1, name: this.$t("GameTypeArcade") },
        { id: 5, state: 1, name: this.$t("GameTypeSport") },
        { id: 6, state: 1, name: this.$t("GameTypeEsport") },
        { id: 7, state: 1, name: this.$t("GameTypeLotto") },
        { id: 8, state: 1, name: this.$t("GameTypePoker") },
        { id: 9, state: 1, name: this.$t("GameTypeOther") },
        { id: 10, state: 1, name: this.$t("GameTypeFishing") },
        { id: 11, state: 1, name: this.$t("GameTypeCrypto") },
        { id: 9999, state: 1, name: this.$t("GameTypeHash") },
      ],
    };
  },
  created() {
    if (
      this.bigSortNewData.rowData.MajorGameOrderNew &&
      this.bigSortNewData.rowData.MajorGameOrderNew != "{}"
    ) {
      let data = JSON.parse(this.bigSortNewData.rowData.MajorGameOrderNew);
      this.tableData = normalizeGameTypeSort(data, this.gameList);
    } else {
      this.tableData = normalizeGameTypeSort(null, this.gameList);
    }
    // this.tableData = this.gameList
    this.tableData.forEach((item) => {
      item.checked = item.state == 1 ? true : false;
    });
  },
  mounted() {
    this.$nextTick(() => {
      this.initSort();
    });
  },
  methods: {
    initSort() {
      const el = document.querySelector(
        "#sortTable .el-table__body-wrapper > table > tbody"
      );
      new Sortable(el, {
        onEnd: (evt) => {
          const currRow = this.tableData.splice(evt.oldIndex, 1)[0];
          this.tableData.splice(evt.newIndex, 0, currRow);
          this.idsArr = [];
          this.tableData.forEach((item, index) => {
            this.idsArr.push(item.id);
          });
        },
      });
    },
    confirmSort(type) {
      let arr = this.tableData.map((item) => {
        return {
          id: item.id,
          name: item.name,
          state: item.checked ? 1 : 2,
        };
      });
      this.bigSortNewData.rowData.MajorGameOrderNew = JSON.stringify(arr);
      this.bigSortNewData.rowData.IsBatch = type;
      this.$emit("confirmBigSortNew", this.bigSortNewData.rowData);
    },
  },
};
</script>
